export const customStyles = {
  control: (provided: any) => ({
    ...provided,
    minHeight: '60px',
    height: '60px',
    maxWidth: '100%',
    flexDirection: 'row !important',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    display: 'flex',
    flexDirection: 'row !important',
    flexWrap: 'nowrap',
    overflowX: 'hidden',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'table !important',
    textOverflow: 'ellipsis',
    marginRight: '4px',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'end',
    height: '60px',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    padding: '2px',
  }),
  clearIndicator: (provided: any) => ({
    ...provided,
    padding: '2px',
  }),
  container: (provided: any) => ({
    ...provided,
    maxWidth: '100%',
  }),
}
